export enum EPromoCodeMode {
  SINGLE = 'single',
  CAMPAIGN = 'campaign',
}

export enum EPromoScopeType {
  SHELL = 'SHELL',
  MOBILE_APP = 'MOBILE_APP',
  BILLING = 'BILLING',
}

export enum EPromoValueType {
  DISCOUNT = 'DISCOUNT',
  DEPOSIT = 'DEPOSIT',
  BONUS = 'BONUS',
}

export enum EPromoCampaignGenerationType {
  SYMBOLS = 'SYMBOLS',
  NUMERIC = 'NUMERIC',
  MIXED = 'MIXED',
}
